export default {
  "content": "<path d=\"M8 5H5v14h3v2H4a1 1 0 01-1-1V4a1 1 0 011-1h4v2z\" fill=\"#7B61FF\"/><path d=\"M13.707 8.207L10.914 11H21v2H10.914l2.793 2.793-1.414 1.414-4.5-4.5a1 1 0 010-1.414l4.5-4.5 1.414 1.414z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};